var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.7999 21.6V14.2964C8.7999 13.6241 9.37298 13.0791 10.0799 13.0791H13.9199C14.6268 13.0791 15.1999 13.6241 15.1999 14.2964V21.6M11.2581 2.62527L2.93811 8.25179C2.60045 8.48014 2.3999 8.84979 2.3999 9.24381V19.7741C2.3999 20.7825 3.25952 21.6 4.3199 21.6H19.6799C20.7403 21.6 21.5999 20.7825 21.5999 19.7741V9.24381C21.5999 8.84979 21.3994 8.48014 21.0617 8.25179L12.7417 2.62527C12.2976 2.32494 11.7022 2.32494 11.2581 2.62527Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.d984bd70948feaa99874d9b7b33489c3.svg";
export { ForwardRef as ReactComponent };